<style lang="scss" src="./VButtonGroup.scss"/>

<script>
import VPopup from "@/lib/components/VPopup/VPopup";
import VButton from "@/lib/components/VButton/VButton";
import UniqueIdMixin from "@/lib/mixins/component-unique-id";

const LAYOUTS = ["panel", "select"];

export default defineComponent({
  name: "VButtonGroup",
  inheritAttrs: true,

  mixins: [UniqueIdMixin],

  components: { VPopup, VButton },

  props: {
    /**
     * Тема иконки. Варианты `default primary success`
     */
    layout: {
      type: String,
      default: "panel",
      validator: value => LAYOUTS.includes(value)
    }
  },

  data() {
    return {
      popupVisible: false,
    };
  },

  computed: {
    selectToggleIcon() {
      if (this.popupVisible === true) {
        return "fa fa-caret-up";
      } else {
        return "fa fa-caret-down";
      }
    },
  },

  methods: {
    generateDefaultChildren() {
      return this.$slots.default?.();
    },

    /**
     * Раскладка select: первая кнопка остаётся на месте, остальные уезжают
     * в попап под кнопкой-стрелкой.
     */
    generateSelectChildren() {
      const defaultSlots = this.$slots.default?.() || [];
      const [main, ...other] = defaultSlots;

      const toggleButton = h(VButton, {
        icon: this.selectToggleIcon,
        onClick: () => {
          this.popupVisible = !this.popupVisible;
        }
      });

      const popup = h(
        VPopup,
        {
          class: {
            "mds-btn-group-popup": true
          },
          target: this,
          visible: this.popupVisible,
          position: "bottom",
          inheritWidth: true,
          noPointer: true,
          offset: 0,
          "onUpdate:visible": (event) => {
            this.popupVisible = event;
          }
        },
        () => other
      );

      return [main, toggleButton, popup];
    },
  },

  render() {
    let children = null;

    switch (this.layout) {
      case "panel":
        children = this.generateDefaultChildren();
        break;
      case "select":
        children = this.generateSelectChildren();
        break;
    }

    const group = h("div", {
      class: {
        "mds-btn-group": true,
        [this.layout]: true
      },
      id: this.uid
    }, children);

    const helperText = this.$slots["helper-text"];

    /** Без слота подписи отдаём голую группу — лишней обёртки в разметке не появляется. */
    if (helperText === undefined) {
      return group;
    } else {
      return h("div", {class: "mds-btn-group-wrap"}, [
        group,
        h("div", {class: "helper-text"}, helperText()),
      ]);
    }
  }
});
</script>
